/*
 * @Author: Src
 * @Date: 2024-11-13 16:01:04
 * @LastEditTime: 2025-05-20 17:21:35
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/systemRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import Config from '@/views/system/Config.vue';
import { AuthEnum } from '@/services/permission.service';

const systemRoutes: RouteConfig = {
  name: 'system',
  path: '/system',
  meta: {
    title: '系统管理',
  },
  redirect: {
    name: 'system.config',
  },
  component: Main,
  children: [
    {
      name: 'system.config',
      path: '/system/config',
      component: Config,
      props: {
        auth: [AuthEnum.参数配置],
      },
      meta: {
        title: '参数配置',
      },
    },
  ],
};

export default systemRoutes;
